import React from 'react';
import { MetricCard, Card, CardTitle, BarRow, Grid, Insight } from '../components/UI';
import { useWaitlistStats, usePassesStats, useRevenueStats, useSavedStats, useCommunityStats } from '../hooks/useAnalytics';

const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
function fmt(n) { return n === null ? '\u2026' : n.toLocaleString(); }
function fmtUSD(n) { return n === null ? '\u2026' : '$' + Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 }); }
function pct(a, b) { return b ? Math.round((a / b) * 100) : 0; }

export default function GrowthOverview({ onNav }) {
  const { count: wlTotal, waiting: wlWaiting } = useWaitlistStats();
  const { data: passes,  loading: pL }          = usePassesStats();
  const { data: rev,     loading: rL }           = useRevenueStats();
  const { data: saved,   loading: sL }           = useSavedStats();
  const { data: comm,    loading: cL }           = useCommunityStats();

  return (
    <div style={{ fontFamily: F }}>

      <Grid cols={4}>
        <MetricCard label="Waitlist"      value={wlTotal === null ? '\u2026' : fmt(wlTotal)}
          sub={wlWaiting !== null ? fmt(wlWaiting) + ' waiting' : undefined}
          trend={wlTotal > 0 ? 'up' : null} accent="#819D84" />
        <MetricCard label="Pass holders"  value={pL ? '\u2026' : fmt(passes?.uniqueUsers || 0)}
          sub={!pL ? fmt(passes?.active || 0) + ' active' : undefined}
          trend={passes?.uniqueUsers > 0 ? 'up' : null} accent="#314F5C" />
        <MetricCard label="Revenue"       value={rL ? '\u2026' : fmtUSD(rev?.totalRev || 0)}
          sub={!rL ? fmt(rev?.total || 0) + ' purchases' : undefined}
          trend={(rev?.totalRev || 0) > 0 ? 'up' : null} accent="#2da06a" />
        <MetricCard label="Community"     value={cL ? '\u2026' : fmt(comm?.totalProfiles || 0)}
          sub={!cL ? fmt(comm?.totalMessages || 0) + ' messages' : undefined}
          accent="#6F8FA7" />
      </Grid>

      <Grid cols={2} mb={0}>
        <Card style={{ marginBottom: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <CardTitle>Pass breakdown</CardTitle>
            <button onClick={() => onNav && onNav('revenue')}
              style={{ fontSize: '.6rem', fontWeight: 600, color: '#6F8FA7', background: '#f0f4f7',
                border: 'none', borderRadius: 5, padding: '3px 9px', cursor: 'pointer' }}>
              Revenue \u2192
            </button>
          </div>
          {pL ? [1,2,3,4].map(i => (
            <div key={i} style={{ height: 12, borderRadius: 6, marginBottom: 10,
              background: 'linear-gradient(90deg,#edf2f5 25%,#f5f7f9 50%,#edf2f5 75%)',
              backgroundSize: '200% 100%', animation: 'shimmer 1.6s ease infinite' }} />
          )) : (
            (passes?.byType || []).length === 0
              ? <Insight type="info">No passes issued yet.</Insight>
              : (passes.byType || []).map(({ type, count }) => (
                  <BarRow key={type} label={type.replace('PASS_', '')} value={fmt(count)}
                    pct={pct(count, (passes.byType[0]?.count) || 1)} labelWidth={70} />
                ))
          )}
        </Card>

        <Card style={{ marginBottom: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <CardTitle>User engagement</CardTitle>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {[
              { label: 'Pass holders',     value: pL ? '\u2026' : fmt(passes?.uniqueUsers || 0) },
              { label: 'Active passes',    value: pL ? '\u2026' : fmt(passes?.active || 0) },
              { label: 'Saved locations',  value: sL ? '\u2026' : fmt(saved?.total || 0) },
              { label: 'Users saving',     value: sL ? '\u2026' : fmt(saved?.uniqueUsers || 0) },
              { label: 'Community members',value: cL ? '\u2026' : fmt(comm?.totalProfiles || 0) },
              { label: 'Channel messages', value: cL ? '\u2026' : fmt(comm?.totalMessages || 0) },
            ].map(({ label, value }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', padding: '9px 0', borderBottom: '.5px solid rgba(49,79,92,.05)' }}>
                <span style={{ fontSize: '.73rem', color: '#4a6878' }}>{label}</span>
                <span style={{ fontSize: '.73rem', fontWeight: 600, color: '#0f1e28' }}>{value}</span>
              </div>
            ))}
          </div>
        </Card>
      </Grid>
    </div>
  );
}
